


















































import { mapActions, mapGetters, mapState } from 'vuex'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { PARKING_NS } from '~/store/modules/shared/parking/state'
import { getRouteMetaItem } from '~/utils/router'
import PlotHeader from '~/components/plot/header/PlotHeader.vue'
import PlotFooter from '~/components/plot/footer/PlotFooter.vue'
import LanguageSwitcher from '~/services/LanguageSwitcher'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import HeadService from '~/services/HeadService'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ClientFlashMessage from '~/components/shared/flash/ClientFlashMessage.vue'
import { FLASH_NS } from '~/store/modules/shared/flash/state'
import BackendFlashMessage from '~/components/car/BackendFlashMessage.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import FlashService from '~/services/flash/FlashService'
import { LOGIN_MODAL_NS } from '~/store/modules/shared/login-modal/state'
import AppNotifications from '~/components/shared/configurable/notification-center/AppNotifications.vue'
import AppConfirmationModal from '~/components/shared/configurable/modal/AppConfirmationModal.vue'
import AppSnackbar from '~/components/car/AppSnackbar.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import GoogleOneTap from '~/components/shared/social-login/GoogleOneTap.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'
import { ANON_GUARD_COOKIE } from '~/constants/anon-guard'

export default defineComponent({
  components: {
    GoogleOneTap,
    AppNotifications,
    BackendFlashMessage,
    PlotFooter,
    PlotHeader,
    ClientFlashMessage,
    AppConfirmationModal,
    AppSnackbar,
    CLoginModal: defineVue3AsyncComponent(() =>
      import('~/components/shared/login/CLoginModal.vue')
    ),
    PiraeusLoanForm: defineVue3AsyncComponent(() =>
      import(
        '~/components/plot/classifieds/view/piraeus-loan/PiraeusLoanForm.vue'
      )
    )
  },
  provide() {
    return {
      i18n: this.$i18n // Alias
    }
  },
  fetch() {
    if (this.isIframe) {
      this.addBodyClass('iframe')
    }
  },
  data() {
    return {
      availableLocales: this.$dep(LanguageSwitcher).getAvailableLocales(),
      isPiraeusLoanFormVisible: false
    }
  },
  computed: {
    ...mapState(LOGIN_MODAL_NS, {
      isLoginModalVisible: state => state.isLoginModalVisible
    }),
    ...mapState(CLASSIFIED_SEARCH_NS, {
      currentRoute: state => state.currentRoute
    }),
    ...mapGetters({
      showParking: 'parking/getShowParking'
    }),
    ...mapGetters(PARKING_NS, {
      showParking: 'getShowParking'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapGetters(USER_NS, {
      isSingleOrAnon: 'isSingleOrAnon'
    }),
    ...mapDeps({
      languageSwitcherService: LanguageSwitcher
    }),
    ...mapState(FLASH_NS, {
      clientFlashMessage: state => state.clientFlashMessage
    }),
    inIndex() {
      return this.$route.name === '__index'
    },
    inAccount() {
      return this.$route.name?.startsWith('__account')
    },
    inMap() {
      return getRouteMetaItem(this.$route, 'inMap')
    },
    inSearchMap() {
      return getRouteMetaItem(this.$route, 'inSearchMap')
    },
    isDealerSite() {
      const dealerSiteService = this.$dep(DealerSiteService)
      return dealerSiteService.routeIsOfDealerSite()
    },
    isNoHeaderRoute() {
      return getRouteMetaItem(this.$route, 'noHeader')
    },
    isNoFooterRoute() {
      return getRouteMetaItem(this.$route, 'noFooter')
    },
    inTrades() {
      return getRouteMetaItem(this.$route, 'inTrades')
    },
    isLanding() {
      return getRouteMetaItem(this.$route, 'isLanding')
    },
    mayShowCreditsAlert() {
      return !this.isIframe
    },
    showFooter() {
      return !this.isIframe && !this.isDealerSite && !this.isNoFooterRoute
    },
    showHeader() {
      return !this.isIframe && !this.isDealerSite && !this.isNoHeaderRoute
    },
    showFlashMessages() {
      return (
        !this.isDealerSite &&
        !this.inMap &&
        !this.inSearchMap &&
        !this.inTrades &&
        !this.isLanding
      )
    },
    showGoogleOneTap() {
      if (process.env.GOOGLE_OAUTH_CLIENT_ID && this.isSingleOrAnon) {
        return (
          getRouteMetaItem(this.$route, 'showOneTap') ||
          (getRouteMetaItem(this.$route, 'showOneTapIfNoAnonModal') &&
            this.$cookies.get(ANON_GUARD_COOKIE))
        )
      }
      return false
    },
    flashService() {
      return this.$dep(FlashService)
    }
  },
  watch: {
    currentRoute(val) {
      this.availableLocales = this.languageSwitcherService.getAvailableLocales(
        val
      )
    },
    $route() {
      this.availableLocales = this.languageSwitcherService.getAvailableLocales()
    }
  },
  beforeMount() {
    this.flashService.setClientFlashFromCookie()
  },
  mounted() {
    window.history.scrollRestoration = 'auto'
    if (this.$route.query['loan-form']) {
      this.isPiraeusLoanFormVisible = true
    }
  },
  methods: {
    ...mapActions(PAGE_NS, {
      addBodyClass: 'addBodyClass'
    })
  },
  head() {
    const headService = this.$dep(HeadService)
    return headService.createLayoutHead()
  }
})
